import { FormControl, FormGroup } from "@angular/forms";
import { Injectable } from '@angular/core';
import { throwIfEmpty } from "rxjs";
import {trim} from 'lodash';

@Injectable({ providedIn: 'root' })
export class UtilsService {
    //不要在这里注入任何其他service，当前service只用来处理简单的功能
    static getBase64(img: File, callback: (img: string) => void): void {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result!.toString()));
        reader.readAsDataURL(img);
    }

    static validateForm(formGroup: FormGroup) {
        for (const key in formGroup.controls) {
            if (formGroup.controls.hasOwnProperty(key)) {
                if (formGroup.controls[key] instanceof FormControl) {
                    // formGroup.controls[key].markAsTouched({ onlySelf: true });
                    formGroup.controls[key].markAsDirty();
                    formGroup.controls[key].updateValueAndValidity();
                } else if (formGroup.controls[key] instanceof FormGroup) {
                    this.validateForm(formGroup.controls[key] as FormGroup);
                }

            }
        }
    }

    static pathJoin(parts: string[], sep = '') {
        var separator = sep || '/';
        return parts.map(x=>trim(x, '/')).join(separator);
    }
}